import React from 'react';
import { BackButton, TextButton as Button, ComponentM, ComponentTextStyle, Size } from '@laerdal/life-react-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { GrayBox, StepContainer, StepDescription, StepTitle } from './StepComponents';
import BreadcrumbTopSection from '../../../../commonComponents/BreadcrumbTopSection';
import { selectMarket, buildMarketPath } from '../../../../store/slices/globalConfigSlice';

interface Step5Props {
  onNext: () => void;
  onPrevious: () => void;
  handleResolvedStep: () => void;
}

const Step5: React.FC<Step5Props> = ({ onNext, onPrevious, handleResolvedStep }) => {
  const { t } = useTranslation(['translation', 'qcprSupport']);
  const currentMarket = useSelector(selectMarket);

  return (
    <StepContainer>
      <BreadcrumbTopSection
        setPadding={false}
        breadcrumb={[
          { text: t('Home', { ns: 'qcprSupport' }), link: buildMarketPath(currentMarket, '/') },
          { text: t('Software and Apps', { ns: 'qcprSupport' }), link: buildMarketPath(currentMarket, '/category/software-and-apps') },
          { text: t('QCPR App', { ns: 'qcprSupport' }), link: buildMarketPath(currentMarket, '/category/software-and-apps/product/qcpr-app') },
          { text: t('Troubleshooting', { ns: 'qcprSupport' }) }
        ]}
      />

      <BackButton onClick={onPrevious} size={Size.Small}>
        {t('Back', { ns: 'qcprSupport' })}
      </BackButton>

      <StepTitle>{t('Have you checked your batteries?', { ns: 'qcprSupport' })}</StepTitle>
      <StepDescription>{t('Batteries drain faster when used regularly.', { ns: 'qcprSupport' })}</StepDescription>

      <GrayBox>
        <ComponentM textStyle={ComponentTextStyle.Bold}>
          {t("Here's what to do", { ns: 'qcprSupport' })}
        </ComponentM>
        <ComponentM textStyle={ComponentTextStyle.Regular}>
          {t('For Little Anne QCPR, Little Junior QCPR and Little Anne Stackable, replace the existing batteries with new.', { ns: 'qcprSupport' })}
        </ComponentM>
        <ComponentM textStyle={ComponentTextStyle.Regular}>
          {t('For Resusci Anne and Little Baby, connect the manakin(s) to a charger and wait until fully charged.', { ns: 'qcprSupport' })}
        </ComponentM>
      </GrayBox>

      <Button
        size={Size.Large}
        onClick={handleResolvedStep} >
        {t("It resolved the issue", { ns: 'qcprSupport' })}
      </Button>

      <Button
        size={Size.Large}
        variant='secondary'
        onClick={() => {
          onNext();
        }}>
        {t("Continue", { ns: 'qcprSupport' })}
      </Button>

      <StepDescription>{t('Your answers will help our team to assist you.', { ns: 'qcprSupport' })}</StepDescription>
    </StepContainer>
  );
};

export default Step5;
